exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AmazonLoadBalancer-AdvancedSettings .StandardFieldLayout .sm-label-right {\n  width: 180px;\n}\n", ""]);

